module.exports = "/_next/static/images/maintenance-840e87037cb8ef25fd23d287ed08fc9a.svg";